import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/btn_close-dark.svg'


const _withScopeId = n => (_pushScopeId("data-v-2d0050a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backdrop" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = { class: "btn-close" }
const _hoisted_4 = {
  ref: "mapContainer",
  class: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)), ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "background",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "image__src",
              src: _imports_0,
              alt: "btn-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_4, null, 512)
        ])
      ])
    ])
  ]))
}